<template>
  <div class="user-info">
    <div class="bgc">
      <van-popover
        trigger="click"
        v-model="showPopover"
        :actions="popoverActions"
        placement="bottom-end"
        @select="popoverOnSelect"
      >
        <template #reference>
          <van-icon class="menu" name="wap-nav" color="#ffffff" />
        </template>
      </van-popover>
    </div>
    <van-image
      round
      class="avatar"
      fit="cover"
      :src="userInfo && userInfo.headimgurl"
    />
    <div class="edit" @click="editClick">编辑资料</div>
    <div class="information" @click="editClick">完善个人资料得140积分</div>
    <div class="user-name">
      <span>{{ userInfo.nickname }}</span>
      <van-image
        v-if="userInfo.role === 1"
        class="official"
        fit="contain"
        :src="require('../../../assets/img/profile-official.jpg')"
      />
    </div>
    <div class="user-id">
      <span> {{ "积分：" + userInfo.score }} </span>
      <span @click="pushMallClick">进入积分商城</span>
    </div>
    <div class="user-sign">
      {{ "等级：" + userInfo.level_msg }}
      <span class="user-sign-rule" @click="userRuleClick">等级规则</span>
    </div>
    <div class="achievement" @click="achievementClick">
      <img
        v-for="item in showAchievements"
        :key="item.title"
        :src="item.img"
        alt=""
      />
    </div>
    <div class="achievementText" @click="achievementClick">
      我的成就（{{ seAchievements.length }}/{{ achievements.length }}）
    </div>
    <div v-if="isShowFansBar" class="fans-tab">
      <div class="fans" @click="attentClick(0)">
        <van-image
          class="icon"
          fit="contain"
          :src="require('../../../assets/img/profile-fans-icon.png')"
        />
        <div class="fans-text">
          <span>粉丝</span>
          <span>{{ userInfo.followers_count }}</span>
        </div>
      </div>
      <div class="fans" @click="attentClick(1)">
        <van-image
          class="icon"
          fit="contain"
          :src="require('../../../assets/img/profile-attent-icon.png')"
        />
        <div class="fans-text">
          <span>关注</span>
          <span>{{ userInfo.followings_count }}</span>
        </div>
      </div>
      <div class="fans" @click="attentClick(2)">
        <van-image
          class="icon"
          fit="contain"
          :src="require('../../../assets/img/profile-collect-icon.png')"
        />
        <div class="fans-text">
          <span>收藏</span>
          <span>{{ userInfo.favorites_count }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAchievements } from "network/profile";
export default {
  name: "userInfo",
  components: {},
  props: {
    userInfo: Object,
    isShowFansBar: Boolean,
  },
  data() {
    return {
      showPopover: false,
      popoverActions: [
        // { text: "我的活动", icon: "smile-o", index: 0 },
        { text: "我的订单", icon: "orders-o", index: 1 },
      ],
      achievements: [],
      seAchievements: [],
      showAchievements: [],
    };
  },
  computed: {},
  created() {
    this.getAchievements();
  },
  mounted() {},
  methods: {
    achievementClick() {
      this.$router.push({ path: "/profileachievement" });
    },
    attentClick(index) {
      this.$emit("fansClick", index);
      if (index === 0) {
        //粉丝
        this.$router.push({ path: "/profilefans" });
      } else if (index == 1) {
        //关注
        this.$router.push({ path: "/profileattent" });
      } else {
        //收藏
        this.$router.push({ path: "/profileColl" });
      }
    },
    //进入积分商城
    pushMallClick() {
      this.$router.push({ path: "/mall" });
    },
    //点击编辑资料
    editClick() {
      this.$router.push({ path: "/infowrittenconsent" });
      // this.$router.push({ path: "/profileclaimpoints" });
    },
    popoverOnSelect(popoverActions) {
      if (popoverActions.index === 0) {
      } else if (popoverActions.index === 1) {
        this.$router.push({ path: "/profileoder" });
      }
    },
    //等级规则
    userRuleClick() {
      this.$router.push({ path: "/graderules" });
    },
    /**
     * 请求
     */
    //我的成就
    getAchievements() {
      getAchievements().then((res) => {
        this.achievements = res.data;
        this.seAchievements = res.data.filter((item) => item.unlocked == true);
        this.showAchievements = this.showAchievements.concat(
          this.seAchievements
        );
        this.achievements.forEach((item) => {
          if (this.showAchievements.length < 3) {
            if (item.unlocked == false) {
              this.showAchievements.push(item);
            }
          }
        });
      });
    },
  },
  watch: {},
};
</script>
<style scoped>
.user-info {
  position: relative;
  background: #f5f5f5;
}
.bgc {
  height: 130px;
  background-image: url(../../../assets/img/profile-back.png);
  background-size: 375px 130px;
}
.bgc-img {
  width: 100%;
  height: 130px;
}
.menu {
  margin-left: 345px;
  margin-top: 10px;
  font-size: 30px;
}

.avatar {
  position: absolute;
  left: 30px;
  top: 80px;
  width: 80px;
  height: 80px;
  border: 1px solid #666;
}
.edit {
  position: absolute;
  right: 20px;
  top: 90px;
  padding: 5px 15px;
  font-size: 13px;
  font-weight: 700;
  background-color: #e5e5e5;
  color: #232323;
}
.information {
  padding-right: 10px;
  font-size: 12px;
  text-decoration: underline;
  color: var(--color-main);
  text-align: right;
}
.user-name {
  padding: 20px 0 0 20px;
  font-weight: 700;
  font-size: 18px;
  color: #232323;
}
.official {
  margin-left: 7px;
  width: 52px;
  height: 14px;
}
.user-id {
  padding: 5px 0 0 20px;
  font-size: 13px;
  color: #232323;
}
.user-id :nth-child(2) {
  margin-left: 15px;
  text-decoration: underline;
  color: var(--color-main);
}
.user-sign {
  padding: 5px 0 0 20px;
  font-size: 13px;
  color: #232323;
}
.user-sign-rule {
  margin-left: 5px;
  font-size: 12px;
  text-decoration: underline;
  color: #707070;
}
.achievement {
  position: absolute;
  top: 180px;
  right: 20px;
}
.achievement img {
  margin-top: 10px;
  margin-left: 6px;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  border: 1px solid #707070;
}
.achievementText {
  position: absolute;
  top: 225px;
  right: 20px;
  text-decoration: underline;
  font-size: 12px;
  color: #333;
}
.fans-tab {
  display: flex;
  justify-content: space-between;
  margin: 20px 20px 0 20px;
}
.fans {
  display: flex;
}
.fans .icon {
  width: 30px;
  height: 35px;
}
.fans-text {
  margin-left: 3px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 13px;
  color: #232323;
}
</style>